// Mock data for portfolio
export const experiences = [
  {
    id: 6,
    company: "OpenText",
    position: "Principal Software Engineer",
    duration: "1st January 2025 - Present",
    location: "Bengaluru, Karnataka, India",
    type: "current",
    responsibilities: [
      "Lead the design, development, and deployment of enterprise-grade software solutions",
      "Define scalable and secure software architectures and conduct architectural reviews",
      "Write, review, and maintain high-quality, standards-compliant code",
      "Collaborate with cross-functional teams to deliver impactful solutions",
      "Optimize system performance and ensure high availability and reliability",
      "Research and integrate emerging technologies into the product roadmap",
      "Establish coding standards, enforce best practices, and ensure security compliance",
      "Mentor and guide team members, fostering a culture of continuous learning",
      "Engage with stakeholders and customers to understand requirements and refine solutions"
    ]
  },
  {
    id: 7,
    company: "OpenText",
    position: "Lead Software Engineer",
    duration: "14th November 2022 - 31st December 2024",
    location: "Bengaluru, Karnataka, India",
    type: "previous",
    responsibilities: [
      "Lead development of enterprise-grade applications",
      "Collaborated with cross-functional teams in Agile development environment",
      "Improved application performance by identifying and fixing bottlenecks and bugs",
      "Optimized, debugged, and profiled to check for memory leaks using Instruments",
      "Adhered to SLA and resolved customer inquiries promptly with minimal business impact",
      "Writing efficient, maintainable, and reusable code with root cause analysis",
      "Participated in customer discussions to understand application requirements"
    ]
  },
  {
    id: 8,
    company: "Infosys Limited",
    position: "Technology Lead",
    duration: "1st July 2019 - 2nd November 2022",
    location: "Bengaluru, Karnataka, India",
    type: "previous",
    responsibilities: [
      "Improvised application performance by identifying and fixing bugs",
      "Optimising, debugging, profiling to check for any possible memory Leaks or memory usage using Instruments",
      "Adhere SLA and resolve customer's inquiries in a timely manner with minimal business impact",
      "Writing efficient, maintainable and reusable code, debugging, analysing its root cause and fixing defects",
      "Programmed adequate code abide by Apple Coding Guidelines",
      "Participate in customer discussions to understand application requirements",
      "Code Review, Guide and Facilitate the Team Members resolve dysfunctional behaviour or any roadblocks",
      "Prototyping/Proof-Of-Concepts for the Enhancements, Feature Requests to help understand the functionality",
      "Expedited the Build Release Process by composing a Shell Script",
      "Researched and Developed Proof-Of-Concepts on NLP and Core ML"
    ]
  },
  {
    id: 9,
    company: "Infosys Limited",
    position: "Technology Analyst",
    duration: "16th November 2015 - 30th June 2019",
    location: "Bengaluru, Karnataka, India",
    type: "previous",
    responsibilities: [
      "Improvised application performance by identifying and fixing bugs",
      "Optimising, debugging, profiling to check for any possible memory Leaks or memory usage using Instruments",
      "Adhere SLA and resolve customer's inquiries in a timely manner with minimal business impact",
      "Writing efficient, maintainable and reusable code, debugging, analysing its root cause and fixing defects",
      "Programmed adequate code abide by Apple Coding Guidelines"
    ]
  },
  {
    id: 10,
    company: "Aricent Technologies (Holdings) Limited (Now Capgemini)",
    position: "Senior Software Engineer",
    duration: "15th December 2014 - 9th November 2015",
    location: "Gurugram, Haryana, India",
    type: "previous",
    responsibilities: [
      "Developed secure Peer-to-Peer Messaging Mobile Application for Beez (Mantu Application)",
      "Collaborated as Team Member (Developer) in Agile Software Development",
      "Created Application Design and Architecture, Database's Entity using Core Data",
      "Programmed code following Apple Coding Guidelines for all screen sizes and orientations"
    ]
  },
  {
    id: 11,
    company: "GlobalLogic India Limited (Now Hitachi Ltd.)",
    position: "Senior Software Engineer",
    duration: "12th December 2013 - 12th December 2014",
    location: "Noida, U.P., India",
    type: "previous",
    responsibilities: [
      "Re-designed and re-engineered existing Enterprise Application for Kohls (Leading Retail Store in US)",
      "Used IBM Worklight Library for calling RESTful services and parsing JSON responses",
      "Used Atlassian's JIRA as Project Management, Collaboration, and Code Quality Tool",
      "Used 3rd party tools like Google Maps, Zxing for bar code scanning, Bugsense, and Crashlytics",
      "Prepared Technical Documentation for modules created using UML"
    ]
  },
  {
    id: 12,
    company: "EBSAVVY Infotech Private Limited",
    position: "Software Engineer",
    duration: "8th August 2011 - 22nd November 2013",
    location: "Noida, U.P., India",
    type: "previous",
    responsibilities: [
      "Developed and programmed multiple applications as Individual Contributor from scratch to app store submission",
      "Designed and pioneered games such as Kellogg's Nutri-Grain Sport Trainer, App Books, and Incredible World",
      "Developed Augmented Reality application based on Image Recognition",
      "Integrated Social Networking Sites such as Facebook, Twitter, and Google into applications",
      "Experience in using Apple's Push Notification (APNS), In-App purchase",
      "Used 3rd party tools like Parse for handling Databases, Mixpanel, Google, and Flurry for analytics"
    ]
  }
];

export const projects = [
  {
    id: 5,
    title: "Purchasing Power Parity",
    description: "Unlock the real value of your money across borders with Purchasing Power Parity! See how far your money goes with the same goods worldwide, instantly see equivalent buying power, plan smarter for travel, study, or budgeting, explore charts showing how economies evolve, and get AI analysis of how the PPP varies.",
    technologies: ["OpenAI", "Telegram Bot", "React", "Python"],
    platform: "Web, Telegram",
    category: "AI/ML",
    isPersonal: true,
    isAppIcon: true,
    image: "/purchasing-power-parity-icon.png",
    features: [
      "AI-powered Purchasing Power Parity calculator with country-level insights.",
      "See how far your money goes with the same goods worldwide",
      "Instantly see equivalent buying power across countries",
      "Plan smarter for travel, study, or budgeting",
      "Explore charts showing how economies evolve",
      "Get AI analysis of how the PPP varies"
    ],
    links: {
      web: "https://rahulsingh.ai/purchasingpowerparity",
      telegram: "https://t.me/purchasing_power_parity_bot"
    }
  },
  {
    id: 6,
    title: "Webroot Total Protection",
    description: "Webroot Digital life protection ensures the safety of your entire online world—your devices, personal data, identity, and privacy—by defending against threats like viruses, scams, identity theft, and data breaches.",
    technologies: ["SwiftUI", "Swift", "C", "C++", "Objective-C++", "CoreData", "Scan Engine"],
    platform: "macOS",
    category: "Security",
    isEnterprise: true,
    image: "https://images.unsplash.com/photo-1614064548237-096f735f344f?w=500&h=300&fit=crop",
    features: [
      "Antivirus: Comprehensive multi-device protection against viruses and malware",
      "Identity Protection: Monitor identity, finances, dark web; 24/7 expert protection",
      "Secure VPN: Stay anonymous, block threats, stream securely, control app connections",
      "Data Protection: Safeguards important files and memories from hardware failures or accidental deletion"
    ],
    links: {
      web: "https://www.webroot.com/us/en"
    }
  },
  {
    id: 7,
    title: "Webroot Mobile Security",
    description: "Webroot harnesses machine learning and artificial intelligence, backed by over 20 years of data and expertise, to make browsing the internet worry-free. It safeguards your mobile device against a wide range of vulnerabilities, including malware, outdated software, jailbreak risks, identity threats, and much more.",
    technologies: ["SwiftUI", "Swift", "CoreData", "Safari Extension", "CI/CD", "Android", "Kotlin"],
    platform: "iPhone & iPad",
    category: "Security",
    image: "https://images.pexels.com/photos/30466736/pexels-photo-30466736.jpeg?w=500&h=300&fit=crop",
    features: [
      "Safe browsing in Safari: Warns before visiting malicious sites & google search annotations",
      "Device vulnerability scanning: Identifies jailbreaks, outdated OS, Wi-Fi, passcode issues",
      "Password manager access: Stores and creates strong, unique passwords securely",
      "Online safety score: Delivers personalized security insights and scoring"
    ],
    links: {
      ios: "https://apps.apple.com/in/app/webroot-mobile-security/id460986853",
      android: "https://play.google.com/store/apps/details?id=com.webroot.wms"
    }
  },
  {
    id: 8,
    title: "CRM Tool (Internal)",
    description: "Worked on internal CRM system to support customer relationship management workflows, focusing on usability, performance, and integration with enterprise services.",
    technologies: ["Objective-C", "XCUITest", "macCatalyst", "Cocoa"],
    platform: "iPad & macOS",
    category: "Enterprise",
    isEnterprise: true,
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3NTY1NTMxODF8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Workflow automation for sales and support teams",
      "Integration with internal enterprise services",
      "Scalable architecture designed for high performance",
      "Enhanced reporting and analytics for business insights"
    ]
  },
  {
    id: 9,
    title: "Mantu IM",
    description: "Mantu is a P2P (PEER TO PEER) instant messaging application ensuring security and convenience",
    technologies: ["Objective-C", "XMPP", "AES Encrypption", "XCTest"],
    platform: "iPhone & iPad",
    category: "Social Networking",
    image: "https://image.winudf.com/v2/image1/MjExNzQ4NjVfMTY4MjI0NDc3Nl8wNTc/screen-0.png?fakeurl=1&type=png",
    features: [
      "Secret Chats with self-destruct timers",
      "Secured chatting between friends and groups",
      "Supports large group chats",
      "Supports transmission of large videos and documents (.doc, .ppt, .zip, etc.)"
    ],
    links: {
      ios: "https://iphone.apkpure.com/app/mantu-im/im.mantu.ionic"
    }
  },
  {
    id: 10,
    title: "Kohl's - Shopping & Discounts (iOS)",
    description: "Kohl's is a popular U.S. retailer offering affordable clothing, footwear, home goods, beauty products, and accessories. It combines trusted national brands with exclusive private-label collections, making it a one-stop destination for families.",
    technologies: ["Objective-C", "Google Maps", "IBM Worklight", "CoreData", "Payment"],
    platform: "iPhone & iPad",
    category: "Enterprise",
    image: "https://images.pexels.com/photos/1666067/pexels-photo-1666067.jpeg?w=500&h=300&fit=crop",
    features: [
      "Strong Brand Equity – High consumer trust and purchase consideration",
      "Kohl's Cash & Promotions – Rewards program with deep seasonal discounts",
      "Exclusive & Private Brands – Unique private labels and designer collections",
      "Omnichannel Shopping – Seamless in-store, online, and mobile experience"
    ],
    links: {
      ios: "https://apps.apple.com/us/app/kohls-shopping-discounts/id373045440"
    }
  },
  {
    id: 11,
    title: "jumpstart",
    description: "jumpstart coaches you with simple breathing and meditative techniques to recharge and energize yourself in just under 10 minutes, so that you can perform at your best through the day.",
    technologies: ["Objective-C", "Core Animation", "Apple Push Notification (APNS)", "Google/Flurry Analytics", "Crashlytics"],
    platform: "iPhone & iPad",
    category: "Health & Wellness",
    image: "https://images.unsplash.com/photo-1492288991661-058aa541ff43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxicmVhdGhpbmd8ZW58MHx8fHwxNzU2NTU0NjM3fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Built-in voice coach for guided breathing sessions",
      "Track your progress over time with detailed analytics",
      "Get reminded for the exercise twice a day automatically",
      "Quick 10-minute sessions designed for busy schedules"
    ],
    links: {
      ios: "https://itunes.apple.com/us/app/jumpstart-boost-energy-improve/id661556834?mt=8"
    }
  },
  {
    id: 12,
    title: "Nutrigrain Sports Trainer",
    description: "The Nutrigrain skill set application is a game application developed for both Android and iOS. The application has two games each for Cricket, Rugby & Soccer. Each section has a Quiz which helps improve the knowledge about each game. It was developed in Lua Scripting language with the help of CORONA tool good for developing games.",
    technologies: ["Objective-C", "Core Animation", "Apple Push Notification (APNS)", "Google/Flurry Analytics", "Lua Scripting", "CORONA"],
    platform: "iPhone & iPad, Android",
    category: "Gaming",
    image: "https://images.unsplash.com/photo-1607627000458-210e8d2bdb1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxzcG9ydHN8ZW58MHx8fHwxNzU2NTU1MzcwfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Six engaging games across Cricket, Rugby & Soccer (two games each)",
      "Interactive quizzes to improve knowledge about each sport",
      "Cross-platform development for both Android and iOS",
      "Built with Lua scripting and CORONA tool for optimal gaming performance"
    ]
  }
];

export const contactInfo = {
  email: "rahulsingh2k10@gmail.com",
  phone: "+91 9911367779",
  linkedin: "https://www.linkedin.com/in/rahulsingh05",
  location: "Bengaluru, Karnataka, India",
  availability: "Open to new opportunities"
};

export const education = [
  {
    id: 1,
    institution: "Orissa Engineering College",
    degree: "B.Tech, Electronics and Telecommunication",
    location: "Bhubaneshwar, Odisha, India",
    duration: "2006 - 2010",
    type: "Bachelor's Degree"
  },
  {
    id: 2,
    institution: "Birla Senior Secondary School",
    degree: "Class XII, Mathematics",
    location: "Pilani, Rajasthan, India",
    duration: "2004 - 2005",
    type: "Higher Secondary"
  },
  {
    id: 3,
    institution: "D A V Public School",
    degree: "Class X, Mathematics",
    location: "Talcher, Odisha, India",
    duration: "2002 - 2003",
    type: "Secondary"
  }
];

export const patents = [
  {
    id: 1,
    title: "Browser Extension Authentication",
    attorneyDocketNo: "US20260082220A1",
    assignee: "Open Text Inc, United States",
    patentId: "US20260082220A1",
    dateOfPatent: "September 16, 2024",
    status: "Pending",
    googlePatentsUrl: "https://patents.google.com/patent/US20260082220A1/en?oq=US+18%2f886%2c819",
    inventors: ["Rahul Singh + 3 Others"],
    category: "Authentication",
    problemStatement: "As of today, it is still impractical to send messages from an iOS containing app to a Safari browser extension due to the uni-directional nature of their communication. Specifically, messages can only be sent from the Safari browser extension to the iOS containing app, but not the other way around. Consequently, the iOS containing app is unable to share authentication data with the Safari browser extension, requiring the user to re-authenticate in the extension before accessing certain features. This limitation results in the user having to authenticate multiple times, which is cumbersome and is the challenge we are trying to accomplish.",
    solution: "To solve the given scenario, we are enabling communication between the iOS containing app and the Safari browser extension through a backend service. This method maintains user integrity without requiring user input, preventing redundant logins and improving the overall user experience by avoiding bad practices. Additionally, the user can pass other data to the Safari browser extension via this service, ensuring seamless communication.",
    approach: "The user first signs into the iOS containing app, which securely stores the session for future authentication. When the Safari browser is launched, the Safari browser extension requests an authentication key from the backend service, which is then shared with the iOS containing app. The iOS containing app links the session data (required for authentication) with the device's unique identifier and the authentication key received from the extension, sending this information to the backend service. Later, when the Safari browser extension tries to use the feature, it authenticates itself by sending the same authentication key to the remote service. The service responds with the data associated with the key, allowing the browser extension to authenticate.",
    technologies: ["iOS", "Safari Extension", "Backend Service", "Authentication", "Session Management"],
    keyInnovations: [
      "Indirect authentication-key exchange — the browser extension only ever receives a reference key, never raw credentials",
      "Native app maps the device's UUID and auth data to that key server-side, so the extension never touches the credential store directly",
      "UUID-based association bridges the native app and browser extension across the mobile OS's app-sandboxing restrictions",
      "Overcomes OS-level limitations that block direct credential sharing between native apps and browser extensions",
      "Eliminates redundant logins — the extension authenticates using the mapped data without the user re-entering credentials",
      "Extensible data-mapping architecture supports credentials, expiration times, and other app-specific data beyond authentication",
      "Stateful, service-managed key-to-data mapping replaces direct peer-to-peer credential sharing entirely"
    ]
  }
];

export const certifications = [
  { id: 9, name: "Generative AI for Beginners", company: "Udemy", year: "2025", icon: "🤖" },
  { id: 10, name: "SwiftUI Essential Training", company: "LinkedIn", year: "2019", icon: "📱" },
  { id: 11, name: "HIPAA Education Program", company: "Oregon Health & Science University", year: "2012", icon: "🏥" },
  { id: 12, name: "Oracle Database SQL Certified Expert", company: "Oracle", year: "2012", icon: "🎖️" }
];

export const awards = [
  { id: 8, name: "Strong Technical Leadership & Ownership", company: "OpenText", month: "Apr", year: "2026" },
  { id: 9, name: "Tackle Challenges Head On", company: "OpenText", month: "Nov", year: "2025" },
  { id: 10, name: "Raise The Bar", company: "OpenText", month: "Nov", year: "2024" },
  { id: 11, name: "We, Not I", company: "OpenText", month: "Jul", year: "2023" },
  { id: 12, name: "We Sweat The Details", company: "OpenText", month: "Jan", year: "2023" },
  { id: 13, name: "Certificate Of Appreciation (Insta)", company: "Infosys Limited", month: "Feb", year: "2022" },
  { id: 14, name: "The Inner Circle", company: "Infosys Limited", month: "Mar", year: "2018" },
  { id: 15, name: "Certificate Of Appreciation (Insta)", company: "Infosys Limited", month: "May", year: "2017" },
  { id: 16, name: "WOW - Team Excellence", company: "Aricent", month: "Oct", year: "2015" },
  { id: 17, name: "GlobalLogic 30 Hacks (2nd Prize)", company: "GlobalLogic", month: "Jul", year: "2014" },
  { id: 18, name: "Value In Performance", company: "EBSAVVY", month: "Nov", year: "2011" }
];